export default {
  install (Vue) {
    // 性别
    Vue.filter('sex', (value) => {
      if (value === '1') {
        return '男'
      }
      if (value === '0') {
        return '女'
      }
      return '未知'
    })
    // 是否文案（Yes Or No）
    Vue.filter('YONText', value => {
      if (value == null) {
        return '/'
      }
      return value ? '是' : '否'
    })
    // 是否启用文案
    Vue.filter('enableText', value => {
      return value ? '启用' : '禁用'
    })
    // 是否禁用文案
    Vue.filter('disabledText', value => {
      return value ? '禁用' : '启用'
    })
    // 是否禁用文案
    Vue.filter('inputFromText', value => {
      if (value === 'PERSON') {
        return '人工'
      }
      if (value === 'AI') {
        return 'AI'
      }
      return '未知'
    })
    // 手机号码
    Vue.filter('mobileText', value => {
      if (value == null || value === '') {
        return ''
      }
      if (value.length !== 11) {
        return value
      }
      return value.substr(0, 3) + '****' + value.substr(-4)
    })
    // 上下架状态
    Vue.filter('statusText', (value) => {
      if (value) {
        return '上架'
      }
      return '下架'
    })
  }
}
